import { html } from 'BomdisoftComponents/html/index';
import type { SnackbarQueueItem } from 'BomdisoftComponents/notifications/snackbars/queue';
import { renderSnack } from 'BomdisoftComponents/notifications/snackbars/render';
import { backOnlineTitle, closeNotificationT, reloadPage, type SupportedLanguage, savedCopyNotice } from '@bomdisoft/translations';

export const SAVED_COPY_MARK = 'bomdisoft-saved-copy';

export const toSavedCopyOfferItem = (language: SupportedLanguage, reload: () => void): SnackbarQueueItem<string> => ({
  anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
  autoHideDuration: null,
  customAction: reload,
  customActionText: reloadPage[language],
  description: savedCopyNotice[language],
  id: 0,
  indicator: 'dot',
  message: backOnlineTitle[language],
  surface: 'paper',
  variant: 'info',
});

export type SavedCopyOfferOptions = { closeTooltipId: string; language: SupportedLanguage };

export const renderSavedCopyOffer = ({ closeTooltipId, language }: SavedCopyOfferOptions) =>
  html`<div class="bomdisoft-snackbars-region" data-anchor="bottom-center" data-testid="saved-copy-offer">${renderSnack(
    toSavedCopyOfferItem(language, () => {}),
    closeNotificationT[language],
    closeTooltipId,
  )}</div>`;
